<template>
    <footer class="footer footer-static footer-light navbar-border">
        <div>
            <center>
            © {{ year }} made with <i class="icon-heart3"></i> by <a>Modern-Expo IT TEAM</a>
            </center>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        components: {},
        data() {
            return {
                year: 0,
            }
        },
        mounted() {
            let y = new Date();
            this.year = y.getFullYear();
        },
        created() {
        },
        methods: {
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue